import { render } from "./Markdown.vue?vue&type=template&id=305ec868"
import script from "./Markdown.vue?vue&type=script&lang=ts"
export * from "./Markdown.vue?vue&type=script&lang=ts"

import "./Markdown.vue?vue&type=style&index=0&id=305ec868&lang=less"
script.render = render

export default script